//import Odometer from 'odometer.js/odometer.js'
export default {
  init() {
    // JavaScript to be fired on all pages

    // VC full-width row
    function resizeFullWidthRow() {
      $('[data-vc-full-width="true"]').each(function () {
        $(this).css({
          width: document.body.clientWidth,
          marginLeft: -document.body.clientWidth / 2,
        })
        if (!$(this).attr('data-vc-stretch-content')) {
          let padding =
            (document.body.clientWidth - $('.container.wrap').outerWidth()) / 2
          $(this).css({
            'padding-left': padding,
            'padding-right': padding,
          })
        }
      })
    }

    var fixedHeader = function () {
      var scroll = $(window).scrollTop()
      if (scroll >= 20) {
        $('.header').addClass('scrolled')
      } else {
        $('.header').removeClass('scrolled')
      }
    }

    function isScrolledIntoView(elem) {
      var $elem = $(elem)
      var $window = $(window)

      var docViewTop = $window.scrollTop()
      var docViewBottom = docViewTop + $window.height()

      var elemTop = $elem.offset().top
      var elemBottom = elemTop + $elem.height()

      return elemBottom <= docViewBottom && elemTop >= docViewTop
    }

    var sectionParallax = function ($this) {
      if ($this.closest('#first_section').length) {
        $this.css({ opacity: 0.95, 'z-index': 0 })
        $(window).scroll(function () {
          var scrollTop = $(this).scrollTop(),
            elementHeight = $this.height(),
            opacity = 1 - (1 - (elementHeight - scrollTop) / elementHeight)
          if (opacity > 0.95) {
            opacity = 0.95
          }
          $this.css('opacity', opacity)
          if ($('.section_shadow').length) {
            $('.section_shadow').css('opacity', opacity)
          }
        })
      } else {
        var elPosition = $this.offset().top
        var elHeight = $this.closest('.transparentize_overlay').outerHeight()
        $(window).scroll(function () {
          if ($(window).scrollTop() > elPosition - $(window).height()) {
            var opacity =
              1 -
              ($(window).scrollTop() - elPosition + $(window).height()) /
                elHeight
            if (opacity < 0) {
              opacity = 0
            }
            $this.css('opacity', opacity)
          }
        })
      }
    }

    //smooth_scroll
    function smooth_scroll(link, e) {
      if (e) {
        e.preventDefault()
        if (e.isTrigger) {
          return false
        }
      }
      var hash = false
      if (!link && window.location.hash) {
        hash = window.location.hash
      } else if (link && link.indexOf('#') == 0) {
        hash = link
      } else if (
        link &&
        location.pathname.replace(/^\//, '') ==
          link.pathname.replace(/^\//, '') &&
        location.hostname == link.hostname
      ) {
        hash = link.hash
      }
      if (hash) {
        $('html, body').animate(
          {
            scrollTop: $(hash).offset().top - $('header.header').outerHeight(),
          },
          600
        )
        if ($(window).scrollTop() == 0) {
          setTimeout(function () {
            $('html, body').animate(
              {
                scrollTop:
                  $(hash).offset().top - $('header.header').outerHeight(),
              },
              600
            )
          }, 500)
        }
        history.replaceState(null, null, hash)
      }
    }
    var delaytime //eslint-disable-line
    //Animate underline
    function underlinedAnimate($elem) {
      window.delaytime = 0
      var char = $elem.find('.line')
      char.each(function () {
        var $this = $(this),
          width = $this.innerWidth(),
          duration = width * 0.001
        $this.css({
          'transition-duration': duration + 's',
          'transition-delay': window.delaytime + 's',
        })
        window.delaytime += duration
        $this.addClass('visible')
      })
    }

    //wrap underline char to span
    function underlineText($elem) {
      if (!$elem.hasClass('wraped') && $(window).width() > 767) {
        $elem.removeClass('inlined')
        var text = $elem.html()
        text = text.replace(/&amp;/g, '&')
        var letters = text.match(/(<\w.*?>|<\/[^>]*>|<\/br>)|(.)/gm)
        if (letters) {
          var spans = letters.map(function (char) {
            if (char.length == 1) {
              if (char == ' ') {
                char =
                  '<span class="line" style="min-width: 0.2em"><span class="char">' +
                  char +
                  '</span></span>'
              } else {
                char =
                  '<span class="line"><span class="char">' +
                  char +
                  '</span></span>'
              }
            }
            return char
          })
          $elem.addClass('wraped').html(spans.join(''))
        }
      } else if ($(window).width() <= 767) {
        $elem.addClass('inlined')
        $elem.removeClass('wraped')
        $elem.find('.char').contents().unwrap()
        $elem.find('.line').contents().unwrap()
      }
    }

    $(document).on(
      'click',
      'a[href^="#"]:not([href="#"],[href="#0"],[href^="#fancy-"],[data-vc-tabs],[role="tab"])',
      function (e) {
        smooth_scroll($(this).attr('href'), e)
      }
    )
    if (window.location.hash) {
      smooth_scroll(window.location.hash)
    }

    resizeFullWidthRow()

    $(window).on('resize', function () {
      resizeFullWidthRow()
    })

    //matchHeight
    $('.matchHeight').matchHeight()

    $(document).ready(function () {
      //First section ID
      $('.wrap.container .main section:first-of-type').attr(
        'id',
        'first_section'
      )

      $('.header').css('position', 'fixed')
      //Fixed header
      fixedHeader()

      //Parallax overlay
      $('.transparentize_overlay .overlay').each(function () {
        sectionParallax($(this))
      })

      //wrap underline char to span
      $('.underlined').each(function () {
        underlineText($(this))
      })
    })

    $(window).scroll(function () {
      //Fixed header
      fixedHeader()
      //Animate line
      $('.underlined').each(function () {
        if (isScrolledIntoView($(this))) {
          underlinedAnimate($(this))
        }
      })
    })

    $(window).resize(function () {
      fixedHeader()

      //Parallax overlay
      $('.transparentize_overlay .overlay').each(function () {
        sectionParallax($(this))
      })

      //wrap underline char to span
      $('.underlined').each(function () {
        underlineText($(this))
      })

      $('.underlined').each(function () {
        if (isScrolledIntoView($(this))) {
          underlinedAnimate($(this))
        }
      })
    })

    $(window).load(function () {
      //Fixed header
      $('.underlined').each(function () {
        if (isScrolledIntoView($(this))) {
          underlinedAnimate($(this))
        }
      })
    })

    //Anker navigation START
    $(document).ready(function () {
      var point = $('.anchor_section')
      var count = point.length
      var i = 0
      if (count > 0) {
        $('.dhsv_vc_anker').fadeIn()
        $('#first_section').append('<div class="navpos"/>')
        $('.footer').prepend('<div class="ankernav_ende"/>')
      } else {
        $('.dhsv_vc_anker').remove()
      }
      point.each(function () {
        i++
        var eID = $(this).attr('id')
        var nav = $('.ankernav')
        nav.addClass('hidenav')
        $('.activebar').css('width', 100 / count + '%')

        nav
          .find('ul')
          .append(
            '<li class="ankernav-li"><a href="#' +
              eID +
              '" class="ankernav-item" style="transition-delay: ' +
              i / 50 +
              's"></a></li>'
          )
      })
      //animate body to Top
      $('.ankernav ul li').on('click', 'a.first_section', function () {
        $('html, body').animate({ scrollTop: 0 }, 500, 'swing')
      })
    })

    $(window).on('scroll', ankerScroll)
    function ankerScroll() {
      var scrolled = $(window).scrollTop()
      var winH = $(window).height()
      var point = $('.anchor_section')
      var nav = $('.ankernav')
      var navPos = $('.navpos')
      var end = $('.ankernav_ende')
      if (end.length) {
        if (
          scrolled + winH / 2 >= navPos.offset().top &&
          scrolled + winH / 2 <= end.offset().top
        ) {
          nav.removeClass('hidenav')
        } else {
          nav.addClass('hidenav')
        }
      } else if (navPos.length) {
        if (scrolled + winH / 2 >= navPos.offset().top) {
          nav.removeClass('hidenav')
        } else {
          nav.addClass('hidenav')
        }
      }

      $('.dhsv_vc_anker').each(function () {
        var tabs = $(this).find('.ankernav')
        var eTop = $(this).offset().top

        if (eTop <= scrolled + 60) {
          $(tabs).addClass('anker-sticky')
        } else {
          $(tabs).removeClass('anker-sticky')
        }
      })
      point.each(function (index) {
        var element = $(this)
        var eID = element.attr('id')
        var eTop = element.offset().top

        if (
          index !== point.length - 1 &&
          point.eq(index + 1).offset().top <= scrolled + winH / 3
        ) {
          $('[href="#' + eID + '"]')
            .parent()
            .removeClass('anker-active')
        } else {
          if (eTop <= scrolled + winH / 3) {
            $('[href="#' + eID + '"]')
              .parent()
              .addClass('anker-active')
          } else {
            $('[href="#' + eID + '"]')
              .parent()
              .removeClass('anker-active')
          }
        }
      })
    } //END Anker Navigation

    /*Parallax background*/
    /*eslint-disable*/
    var $parallaxEl = $('.parallax_bg')
    var speed = -0.25
    window.onscroll = function () {
      $parallaxEl.each(function () {
        var elPos = $(this).offset().top
        var windowYOffset = window.pageYOffset,
          elBackgrounPos = '50% ' + (windowYOffset - elPos) * speed + 'px'
        $(this).css('background-position', elBackgrounPos)
      })
    }
    /*eslint-enable*/
    /*END Parallax background*/

    //Gform Inputs
    let gFormInputs = function () {
      $('.gfield_error').addClass('selected')
      var fields = $('.gfield input, .gfield textarea, select')

      fields.each(function () {
        if ($(this).val() !== '') {
          var parent = $(this).closest('.gfield')
          parent.addClass('selected')
        }
      })

      fields.bind('focus', function () {
        var parent = $(this).closest('.gfield')
        parent.addClass('selected')
      })

      fields.on('change', function () {
        var parent = $(this).closest('.gfield')
        parent.addClass('selected')
      })

      fields.bind('focusout', function () {
        var current = $(this)
        var parent = current.closest('.gfield')
        if (current.val() === '' && parent.hasClass('selected')) {
          if (!parent.hasClass('gfield_error')) {
            parent.removeClass('selected')
          }
        }
      })
    }

    $(document).bind('gform_post_render', function () {
      $('.ginput_container_select')
        .closest('.gfield')
        .each(function () {
          if (!$(this).hasClass('select_field')) {
            $(this).addClass('select_field')
          }
        })
      if (typeof gFormInputs == 'function') {
        gFormInputs()
      }
    })

    // fix bug if fields are conditional not visible at first render
    $('body').on(
      'DOMSubtreeModified',
      '.gfield .ginput_container .slider-display .noUi-tooltip',
      e => {
        const value = e.target.textContent
        if (value) {
          const input = $(e.target).closest('.ginput_container').find('input')
          input.val(value)
        }
      }
    )
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    //Add custom arrows to slider
    $('.standard_style .animated_slider')
      .find('.slick-prev, .slick-next')
      .html('<span></span><span></span>')

    $('.simple_style .animated_slider, .timeline_items')
      .find('.slick-prev, .slick-next')
      .html(
        '<span class="circle"><span><em></em></span><span><em></em></span></span>'
      )
  },
}
